import { useQuery } from '@tanstack/react-query';

import { mmFetch } from 'api/mmFetch';
import { ApiError } from 'shared/errors/ApiError';

export const FBM_SWAGGER_SPEC_QUERY_KEY = 'fbmSwaggerSpec';

export const fbmSwaggerSpecQueryKeys = {
    all: [FBM_SWAGGER_SPEC_QUERY_KEY],
};

/**
 * @returns {import('@tanstack/react-query').UseQueryResult<Object, ApiError>}
 */
export function useFbmSwaggerSpecQuery() {
    return useQuery({
        queryKey: fbmSwaggerSpecQueryKeys.all,
        queryFn: async () => {
            const response = await mmFetch('api/api-docs/v1/ptnr/swagger');
            if (!response.ok) {
                throw new ApiError(`Failed to fetch FBM swagger spec`, response.status);
            }
            return response.json();
        },
        staleTime: 30 * 60_000,
        gcTime: 60 * 60_000,
        retry: (failureCount, error) => {
            if (error instanceof ApiError && error.isServerError) {
                return false;
            }
            if (error instanceof ApiError && error.isAuthError) {
                return false;
            }
            return failureCount < 2;
        },
    });
}
